export enum Privacy {
	Public = "public",
	Private = "private",
}

export enum FantasySeries {
	Crankworx = "Crankworx",
	WorldChamps = "UCI World Championships",
	WorldCup = "UCI World Cup",
	RedBullRampage = "Red Bull Rampage",
	RedBullHardline = "Red Bull Hardline",
}

export enum FantasySports {
	Downhill = "Downhill",
	Enduro = "Enduro",
	SlopeStyle = "SlopeStyle",
}

export enum Gender {
	male = "m",
	female = "f",
}

export enum RiderStatus {
	injured = "injured",
	active = "active",
	inactive = "inactive",
}

export enum ResultPhase {
	Qualifying = "qualifying_data",
	Semis = "semis_data",
	Finals = "finals_data",
}

export enum GameModeAssignemts {
	Multiplier = "Multiplier Mode", 
	Budget = "Budget Mode",
	PickAndRank = "Pick and Rank",
	PickAndRankHardline = "Pick and Rank Hardline",
}